import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import isPrimitive from '../is/is-primitive.js';
import mapNodeToFragment from '../map/map-node-to-fragment.js';
import createNewItems from './create-new-items.js';
const ARRAY_INDEX_OFFSET = 1;
const VARIABLE_PREFIX = '$';
export default function replaceVariables(translation, vars) {
    if (typeof vars === 'undefined') {
        return translation;
    }
    const newTranslation = [translation];
    const SKIP = 2;
    for (const [variable, value] of Object.entries(vars)) {
        for (let translationIndex = 0; translationIndex < newTranslation.length; translationIndex += SKIP) {
            const item = newTranslation[translationIndex];
            const newItems = createNewItems(item, variable, value);
            newTranslation.splice(translationIndex, VARIABLE_PREFIX.length, ...newItems);
            translationIndex += newItems.length - ARRAY_INDEX_OFFSET;
        }
    }
    if (newTranslation.every(isPrimitive)) {
        return newTranslation.join('');
    }
    return _jsx(_Fragment, { children: newTranslation.map(mapNodeToFragment) });
}
//# sourceMappingURL=replace-variables.js.map